import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  hiddenFileInput: {
    display: "none",
  },
  filePickerBox: {
    padding: theme.spacing(2),
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
  },
}));

export default function PrescriptionModal({
  open,
  form,
  loading,
  title = "ثبت نسخه جدید",
  submitLabel = "ثبت نسخه",
  onClose,
  onChange,
  onSubmit,
}) {
  const classes = useStyles();

  const updateForm = (updates) => {
    onChange((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="عنوان نسخه"
              value={form.title}
              onChange={(event) => updateForm({ title: event.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.filePickerBox}>
              {form.imageUrl && (
                <div className="mb-2">
                  <img
                    src={form.imageUrl}
                    alt="نسخه"
                    style={{
                      display: "block",
                      maxWidth: "100%",
                      maxHeight: 220,
                      objectFit: "contain",
                      marginBottom: 8,
                    }}
                  />
                </div>
              )}
              <Button variant="outlined" color="primary" component="label">
                {form.imageUrl ? "تغییر فایل نسخه" : "انتخاب فایل نسخه"}
                <input
                  className={classes.hiddenFileInput}
                  type="file"
                  accept="image/*"
                  onChange={(event) =>
                    updateForm({ image: event.target.files?.[0] || null })
                  }
                />
              </Button>
              <Typography variant="caption" display="block" className="mt-2">
                {form.image?.name ||
                  (form.imageUrl
                    ? "برای حفظ عکس فعلی، فایل جدید انتخاب نکنید."
                    : "فایلی انتخاب نشده است.")}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              variant="outlined"
              label="نام پزشک"
              value={form.doctorName}
              onChange={(event) => updateForm({ doctorName: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="SPH چشم راست"
              value={form.rightEyeSph}
              onChange={(event) => updateForm({ rightEyeSph: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="CYL چشم راست"
              value={form.rightEyeCyl}
              onChange={(event) => updateForm({ rightEyeCyl: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="AXE چشم راست"
              value={form.rightEyeAxe}
              onChange={(event) => updateForm({ rightEyeAxe: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="SPH چشم چپ"
              value={form.leftEyeSph}
              onChange={(event) => updateForm({ leftEyeSph: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="CYL چشم چپ"
              value={form.leftEyeCyl}
              onChange={(event) => updateForm({ leftEyeCyl: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              label="AXE چشم چپ"
              value={form.leftEyeAxe}
              onChange={(event) => updateForm({ leftEyeAxe: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label="PD"
              value={form.pd}
              onChange={(event) => updateForm({ pd: event.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              label="ADD"
              value={form.add}
              onChange={(event) => updateForm({ add: event.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              variant="outlined"
              label="توضیحات نسخه"
              value={form.description}
              onChange={(event) => updateForm({ description: event.target.value })}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          انصراف
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
